var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"classifier",class:'classifier-' + _vm.type},[_c('classifier-ball',{attrs:{"type":_vm.type}},[_vm._v(_vm._s(_vm.count))]),_c('label',[_vm._v(_vm._s(_vm.typeLabel))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }